<script>
export default {
  name: 'PodcastSliderCard',
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <a :href="data.url" class="kb-podcast-slider-card" draggable="true">
    <div v-if="data.imageUrl" class="kb-podcast-slider-card__image">
      <img :src="data.imageUrl" :alt="data.imageAlt ?? ''" />
    </div>

    <p class="kb-podcast-slider-card__date">{{ data.date }}</p>

    <h3 class="kb-podcast-slider-card__title">{{ data.title }}</h3>
  </a>
</template>
